import { render } from "./Authenticate.vue?vue&type=template&id=24ae1c00&ts=true"
import script from "./Authenticate.vue?vue&type=script&lang=ts"
export * from "./Authenticate.vue?vue&type=script&lang=ts"

import "./Authenticate.vue?vue&type=style&index=0&id=24ae1c00&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__